<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', false)"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  [class]="isShowDetailPage ? 'd-none' : ''"
>
  <!---------------------------------- Table Content ---------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- organizationName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- phonebookCustomFieldNameEn -->
        <td class="tw-py-2">
          <td-value
            copyToClipboard
            [value]="item?.phonebookCustomFieldNameEn"
          ></td-value>
        </td>

        <!-- calenderEventTitle -->
        <td class="tw-py-2">
          <td-value
            copyToClipboard
            [value]="item?.calenderEventTitle"
          ></td-value>
        </td>

        <!-- calenderOrganizationEventTitle -->
        <td class="tw-py-2">
          <td-value
            copyToClipboard
            [value]="item?.calenderOrganizationEventTitle"
          ></td-value>
        </td>

        <!-- dynamicTemplateTitle -->
        <td class="tw-py-2">
          <td-value
            copyToClipboard
            [value]="item?.dynamicTemplateTitle"
          ></td-value>
        </td>

        <!-- privateNumber -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.privateNumber"></td-value>
        </td>

        <!-- isActive -->
        <td>
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- howManyDaysSendItBeforeDueDate -->
        <td class="tw-py-2">
          <td-value
            copyToClipboard
            [value]="item?.howManyDaysSendItBeforeDueDate"
          ></td-value>
        </td>

        <!-- sendDateTime -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.sendDateTime"></td-value>
        </td>

        <!-- created -->
        <td class="tw-py-2">
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!---------------------------------- operations ---------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete($event.id, '')"
            (onUpdate)="onUpdate($event?.id)"
            (onDetail)="onDetail($event?.id)"
            [isShowDetailsBtn]="
              item?.organizationId != userSession.organizationId()
            "
            [isShowEditBtn]="
              item?.organizationId == userSession.organizationId()
            "
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-send-occasion-sms
    [formPageConfig]="formPageConfig"
    [selectedPhonebooks]="selectedPhonebooks"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-send-occasion-sms>
</ng-container>

<!-- detail -->
<app-occasion-scheduled-messages-details
  [model]="detailModel"
  *ngIf="isShowDetailPage"
  (closePage)="
    isShowDetailPage = false; showParent = true; getParentQueryString()
  "
>
</app-occasion-scheduled-messages-details>

<!-- Audit -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    methodName="occasionScheduledMessagesGetOccasionScheduledMessageAuditWithPagination"
    [sortReferenceId]="false"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
<!---------------------------------- help ---------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
